import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M6 3h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 8h12", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 13 8.5 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M6 13h3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 13c6.667 0 6.667-10 0-10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "IndianRupee";
const IndianRupee = memo(themed(Icon));
export {
  IndianRupee
};
//# sourceMappingURL=indian-rupee.js.map
